import Info from '@mui/icons-material/Info';
import { IconButton } from '@qbe/ads-core';
import React, { ReactNode } from 'react';

import { useHelperText } from '../HelperTextProvider/useHelperText';

export const ContextualHelpWithButton = ({
  children,
  tracking,
}: {
  children: ReactNode;
  tracking?: string;
}) => {
  const { openHelper } = useHelperText();

  return (
    <IconButton
      data-testid="helper-text__help-button"
      data-track={tracking}
      onClick={openHelper(children)}
      iconProps={{ muiIcon: Info }}
    />
  );
};
